import React from 'react'
import { Card, CardContent, CardTitle, CardDescription } from '../ui/Card'
import CreditScoreProgressBar from '../shared/CreditScoreProgressBar'

const statusTierInfo = {
  1: { class: 'bg-success', text: 'Excellent' },
  2: { class: 'bg-primary', text: 'Good' },
  3: { class: 'bg-warning', text: 'Fair' },
  4: { class: 'bg-danger', text: 'Needs some love' },
  5: { class: 'bg-danger', text: 'Needs extra love' },
}

const CreditFactor = ({ label, value, statusTier, impact }) => {
  return (
    <div className='mb-3 fs-5'>
      <div className='d-flex align-items-center gap-2 mb-1'>
        <span className='fw-bold'>{label}:</span>
        <span className='fw-bold'>
          {typeof value === 'object' ? `${value.years} yrs, ${value.months} mos` : value}
          {typeof value === 'number' &&
          !label.includes('Accounts') &&
          !label.includes('Marks') &&
          !label.includes('Inquiries')
            ? '%'
            : ''}
        </span>
      </div>
      <div className='d-flex align-items-center gap-2'>
        <span className={`badge ${statusTierInfo[statusTier].class}`}>
          {statusTierInfo[statusTier].text}
        </span>
        <span className='text-muted small'>|</span>
        <span className='text-muted small'>{impact} Impact</span>
      </div>
    </div>
  )
}

const CreditScoreDisplay = ({ score }) => {
  return (
    <div className='credit-score-panel bg-white rounded position-relative p-4 mb-4'>
      <div className='text-center mb-5'>
        <div className='d-flex align-items-baseline justify-content-center'>
          <span
            id='credit-score-value'
            style={{
              fontSize: '80px',
              fontWeight: 'bold',
              lineHeight: '1',
              color: '#000',
            }}
          >
            {score || 'N/A'}
          </span>
          <span
            style={{
              fontSize: '24px',
              color: '#6c757d',
              marginLeft: '4px',
            }}
          >
            /850
          </span>
        </div>
      </div>
      <CreditScoreProgressBar score={score} />
    </div>
  )
}

const CreditReportCard = ({ creditReport }) => {
  const factors = [
    { key: 'payment_history', label: 'Payment History' },
    { key: 'credit_utilization', label: 'Credit Card Usage' },
    { key: 'derogatory_marks', label: 'Derogatory Marks' },
    { key: 'credit_age', label: 'Credit Age' },
    { key: 'total_accounts', label: 'Total Accounts' },
    { key: 'hard_inquiries', label: 'Hard Inquiries' },
    { key: 'available_credit', label: 'Available Credit' },
  ]

  const score = creditReport.credit_score?.value
  const statusTier = creditReport.credit_score?.status_tier

  return (
    <Card id='credit-report'>
      <CardContent>
        <CardTitle>
          <h2 className='mb-3 fs-1'>Credit Score</h2>
          {score && statusTier && (
            <div className='d-flex align-items-center gap-2 mb-4'>
              <span className={`badge ${statusTierInfo[statusTier].class}`}>
                {statusTierInfo[statusTier].text}
              </span>
              <span className='text-muted'>|</span>
              <span className='text-muted'>Model: FICO</span>
            </div>
          )}
        </CardTitle>
        <CardDescription>
          <div className='row'>
            <div className='col-12'>
              {creditReport.credit_score && (
                <CreditScoreDisplay score={creditReport.credit_score.value} />
              )}
              <h5 className='mb-4 fs-4'>Factors affecting your score:</h5>
              <div className='d-flex flex-column gap-4'>
                {creditReport.credit_score?.score_reasons?.map((reason, index) => (
                  <div key={index} className='d-flex align-items-center gap-3'>
                    <div
                      className='d-flex align-items-center justify-content-center rounded-circle bg-light'
                      style={{ width: '40px', height: '40px', flexShrink: 0 }}
                    >
                      <span className='text-secondary fw-medium'>{index + 1}</span>
                    </div>
                    <div>{reason}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <h3 className='mb-3 mt-5'>Credit Factors</h3>
          <p className='mb-3'>{creditReport.improvement_message}</p>
          {factors.map(({ key, label }) => (
            <CreditFactor
              key={key}
              label={label}
              value={creditReport[key].value}
              statusTier={creditReport[key].status_tier}
              impact={creditReport[key].impact}
            />
          ))}
        </CardDescription>
      </CardContent>
    </Card>
  )
}

export default CreditReportCard
